import React, { Component } from 'react';
import axios from 'axios';
import ReactDOM from 'react-dom/client';
import Swal from 'sweetalert2';
import httpService from '../services/http.service';
import { currency_format, t } from '../utils';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { isFullScreen, toogleFullScreen } from '../fullscreen';
import { Modal } from 'bootstrap';
import uuid from 'react-uuid';
import { ArrowRightIcon, XCircleIcon, Squares2X2Icon, ArrowPathIcon, ArrowLeftIcon, ChevronDownIcon } from '@heroicons/react/24/outline';
import { UserCircleIcon } from '@heroicons/react/24/solid';
// @ts-ignore
import Quagga from 'quagga';
const priceFilterList = [
    'Unit Prices',
    'Box Prices',
    'Wholesale Price',
    // "Price per Gram",
    // "Price per Kilogram"
    'Currency',
];
const currencyFilterList = [
    'USD',
    'LLP',
];
const tableStyles = {
    width: '100%',
    tableLayout: 'auto',
    borderCollapse: 'collapse', // 'collapse' is now correctly typed
};
class PointOfSale extends Component {
    constructor(props) {
        super(props);
        // -----------------
        this.updateTotalPrice = (bucketInputs = this.state.bucketInputs) => {
            const overallTotal = Object.values(bucketInputs).reduce((acc, { qty = 0, cost = 0 }) => acc + qty * cost, 0);
            this.setState({ bucketTotalPrice: overallTotal }, () => this.calculateTotal());
        };
        // Handler for quantity change.
        this.handleQtyChange = (bucketId, event) => {
            const qty = parseFloat(event.target.value) || 0;
            this.setState((prevState) => ({
                bucketInputs: Object.assign(Object.assign({}, prevState.bucketInputs), { [bucketId]: Object.assign(Object.assign({}, prevState.bucketInputs[bucketId]), { qty }) }),
            }), () => this.updateTotalPrice(this.state.bucketInputs));
        };
        // Handler for cost change.
        this.handleCostChange = (bucketId, event) => {
            const cost = parseFloat(event.target.value) || 0;
            this.setState((prevState) => ({
                bucketInputs: Object.assign(Object.assign({}, prevState.bucketInputs), { [bucketId]: Object.assign(Object.assign({}, prevState.bucketInputs[bucketId]), { cost }) }),
            }), () => this.updateTotalPrice(this.state.bucketInputs));
        };
        // ===============================
        // Handlers for returned buckets
        // ===============================
        this.handleReturnQtyChange = (bucketId, event) => {
            const qty = parseFloat(event.target.value) || 0;
            this.setState((prevState) => ({
                returnBucketInputs: Object.assign(Object.assign({}, prevState.returnBucketInputs), { [bucketId]: Object.assign(Object.assign({}, prevState.returnBucketInputs[bucketId]), { qty }) }),
            }), () => this.updateReturnTotalPrice(this.state.returnBucketInputs));
        };
        this.handleReturnCostChange = (bucketId, event) => {
            const cost = parseFloat(event.target.value) || 0;
            this.setState((prevState) => ({
                returnBucketInputs: Object.assign(Object.assign({}, prevState.returnBucketInputs), { [bucketId]: Object.assign(Object.assign({}, prevState.returnBucketInputs[bucketId]), { cost }) }),
            }), () => this.updateReturnTotalPrice(this.state.returnBucketInputs));
        };
        this.updateReturnTotalPrice = (returnBucketInputs = this.state.returnBucketInputs) => {
            const overallReturnTotal = Object.values(returnBucketInputs).reduce((acc, { qty = 0, cost = 0 }) => acc + qty * cost, 0);
            this.setState({ returnBucketTotalPrice: overallReturnTotal }, () => this.calculateTotal());
        };
        // ===============================
        // Handlers for returned buckets
        // ===============================
        // Update the stock value for a given bucket in plastic_bucket_stock.
        this.handleStockChange = (bucketId, event) => {
            const stock = parseInt(event.target.value, 10) || 0;
            this.setState((prevState) => ({
                plastic_bucket_stock: Object.assign(Object.assign({}, prevState.plastic_bucket_stock), { [bucketId]: Object.assign(Object.assign({}, prevState.plastic_bucket_stock[bucketId]), { stock }) }),
            }));
        };
        this.specialCustomerPrice = (prod) => {
            if (!this.state.customer)
                return prod.price || 0;
            if (this.state.customer.order_details.length == 0)
                return prod.price || 0;
            var newProd = this.state.customer.order_details.find(p => p.product_id === prod.id);
            if (!newProd)
                return prod.price || 0;
            return newProd.price || 0;
        };
        this.getCategories = () => {
            // console.log("ASDASD");
            httpService
                .get(`inventory/categories`)
                .then((response) => {
                this.setState({ categories: response.data.data });
            })
                .finally(() => {
                this.setState({ isLoadingCategories: false });
            });
        };
        this.storeOrder = () => {
            var _b, _j, _k;
            if (this.state.cart.length == 0) {
                toast.error(t('No items has been added!', 'لم يتم إضافة اية اصناف!'));
                return;
            }
            this.setState({ isLoading: true });
            var _deliveryCharge = 0;
            if (this.getAppSettings().enableTakeoutAndDelivery) {
                _deliveryCharge = this.isOrderDelivery() ? this.state.deliveryCharge || 0 : 0;
            }
            else {
                _deliveryCharge = this.state.deliveryCharge || 0;
            }
            // console.log(this.state);
            // sdfdsf;
            httpService
                .post(`/order`, {
                customer: this.state.customer,
                cart: this.state.cart,
                subtotal: this.state.subtotal,
                total: this.state.total,
                tax_rate: this.state.tax || 0,
                vat_type: this.state.vatType,
                delivery_charge: _deliveryCharge,
                discount: this.state.discount || 0,
                remarks: this.state.remarks,
                type: this.state.orderType,
                tender_amount: this.state.tenderAmount || 0,
                return_amount: this.state.returnAmount || 0,
                price_type: this.state.currentPrice || 0,
                paid: this.state.isPaid,
                is_quotation: this.state.isQuotation,
                bucketId: this.state.bucketId,
                bucketName: this.state.bucketName,
                bucketStock: this.state.bucketStock,
                bucketUnitPrice: this.state.bucketUnitPrice,
                salesman_name: (_b = this.state.selectedSalesman) === null || _b === void 0 ? void 0 : _b.salesman_name,
                root_name: (_j = this.state.selectedRoot) === null || _j === void 0 ? void 0 : _j.root_name,
                line_name: (_k = this.state.selectedLine) === null || _k === void 0 ? void 0 : _k.location,
                currency: this.state.currency,
                bucketInputs: this.state.bucketInputs,
                bucketTotalPrice: this.state.bucketTotalPrice,
                returnBucketInputs: this.state.returnBucketInputs,
                returnBucketTotalPrice: this.state.returnBucketTotalPrice,
            })
                .then((response) => {
                if (response.data) {
                    this.resetPos();
                    toast.info(t('Saved!', 'تم الحفظ'));
                    this.closeModal('checkoutModal');
                    console.log(response.data);
                    this.printInvoice(response.data, this.getAppSettings());
                }
            })
                .finally(() => {
                var _b, _j, _k;
                console.log({
                    customer: this.state.customer,
                    cart: this.state.cart,
                    subtotal: this.state.subtotal,
                    total: this.state.total,
                    tax_rate: this.state.tax || 0,
                    vat_type: this.state.vatType,
                    delivery_charge: _deliveryCharge,
                    discount: this.state.discount || 0,
                    remarks: this.state.remarks,
                    type: this.state.orderType,
                    tender_amount: this.state.tenderAmount || 0,
                    return_amount: this.state.returnAmount || 0,
                    customer_amount: this.state.customerAmount || 0,
                    price_type: this.state.currentPrice || 0,
                    paid: this.state.isPaid,
                    is_quotation: this.state.isQuotation,
                    salesman_name: (_b = this.state.selectedSalesman) === null || _b === void 0 ? void 0 : _b.salesman_name,
                    root_name: (_j = this.state.selectedRoot) === null || _j === void 0 ? void 0 : _j.root_name,
                    line_name: (_k = this.state.selectedLine) === null || _k === void 0 ? void 0 : _k.location,
                    currency: this.state.currency,
                    bucketTotalPrice: this.state.bucketTotalPrice,
                    bucketInputs: this.state.bucketInputs,
                });
                this.setState({ isLoading: false });
            });
        };
        this.reset = () => {
            Swal.fire({
                title: t('Reset?', 'إعادة ضبط'),
                text: t('Any unsaved changes will be lost', 'ستفقد أي تغييرات غير محفوظة'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: t('Reset?', 'إعادة ضبط'),
                cancelButtonText: t('Cancel', 'إلغاء')
            }).then(result => {
                if (result.isConfirmed) {
                    this.resetPos();
                }
            });
        };
        // --- Scan Barcode
        this.scan_barcode = () => {
            const scannerOverlay = document.createElement('div');
            scannerOverlay.id = 'scanner-overlay';
            scannerOverlay.style.position = 'fixed';
            scannerOverlay.style.top = '0';
            scannerOverlay.style.left = '0';
            scannerOverlay.style.width = '100%';
            scannerOverlay.style.height = '100%';
            scannerOverlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
            scannerOverlay.style.display = 'flex';
            scannerOverlay.style.justifyContent = 'center';
            scannerOverlay.style.alignItems = 'center';
            scannerOverlay.style.zIndex = '1000';
            const scannerContainer = document.createElement('div');
            scannerContainer.id = 'scanner-container';
            scannerContainer.style.position = 'relative';
            scannerContainer.style.width = '90%';
            scannerContainer.style.height = '90%';
            scannerContainer.style.backgroundColor = '#fff';
            scannerOverlay.appendChild(scannerContainer);
            // Add focus line
            const focusLine = document.createElement('div');
            focusLine.style.position = 'absolute';
            focusLine.style.left = '10%';
            focusLine.style.width = '80%';
            focusLine.style.height = '2px';
            focusLine.style.backgroundColor = 'rgba(255, 0, 0, 0.7)';
            focusLine.style.top = '10%';
            scannerContainer.appendChild(focusLine);
            // Animate focus line
            let direction = 1; // 1 for moving down, -1 for moving up
            const animationSpeed = 5; // Pixels per step
            const animationInterval = 30; // Time interval (ms)
            const animateFocusLine = () => {
                const currentTop = parseInt(focusLine.style.top || '10%', 10);
                const nextTop = currentTop + direction * animationSpeed;
                // Bounce the line when it reaches the container edges
                if (nextTop <= 10 || nextTop >= scannerContainer.offsetHeight - 10) {
                    direction *= -1;
                }
                focusLine.style.top = `${nextTop}px`;
            };
            const animationId = setInterval(animateFocusLine, animationInterval);
            document.body.appendChild(scannerOverlay);
            // Initialize Quagga
            Quagga.init({
                inputStream: {
                    name: 'Live',
                    type: 'LiveStream',
                    target: scannerContainer,
                    constraints: {
                        width: { min: 640, ideal: 1280, max: 1920 },
                        height: { min: 480, ideal: 720, max: 1080 },
                        facingMode: 'environment'
                    }
                },
                decoder: {
                    readers: ['code_128_reader']
                }
            }, (err) => {
                if (err) {
                    console.error('Error initializing Quagga:', err);
                    if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
                        alert('Camera permission is required to scan barcodes.');
                    }
                    else if (err.name === 'NotFoundError') {
                        alert('No camera detected on this device.');
                    }
                    else {
                        alert('Error accessing the camera. Please try again.');
                    }
                    document.body.removeChild(scannerOverlay);
                    return;
                }
                Quagga.start();
            });
            Quagga.onDetected((data) => {
                const barcodeValue = data.codeResult.code;
                console.log('Barcode detected:', barcodeValue);
                // Stop the scanner and remove the overlay
                Quagga.stop();
                clearInterval(animationId); // Stop animation
                document.body.removeChild(scannerOverlay);
                // Use the barcode value
                this.setCustomer({
                    id: '1',
                    name: barcodeValue,
                    full_address: 'Scanned Address',
                    contact: 'Scanned Contact',
                    balance: 0,
                    order_details: []
                });
            });
            scannerOverlay.addEventListener('click', () => {
                Quagga.stop();
                clearInterval(animationId); // Stop animation
                document.body.removeChild(scannerOverlay);
            });
        };
        this.resetPos = () => {
            var settings = this.getAppSettings();
            this.setState({ products: [] });
            this.setState({ cart: [] });
            this.setState({ customers: [] });
            this.setState({ customer: undefined });
            this.setState({ customerName: null });
            this.setState({ customerEmail: null });
            this.setState({ customerMobile: null });
            this.setState({ customerCity: null });
            this.setState({ customerBuilding: null });
            this.setState({ customerStreet: null });
            this.setState({ customerFloor: null });
            this.setState({ customerApartment: null });
            this.setState({ bucketNumber: null });
            this.setState({ showProducts: false });
            this.setState({ categoryName: '' });
            this.setState({ subtotal: 0 });
            this.setState({ deliveryCharge: settings.deliveryCharge });
            this.setState({ total: 0 });
            this.setState({ discount: settings.discount });
            this.setState({ tax: settings.taxRate });
            this.setState({ vatType: settings.vatType });
            this.setState({ searchValue: null });
            this.setState({ remarks: null });
            this.setState({ tenderAmount: 0 });
            this.setState({ returnAmount: 0 });
            this.setState({ customerAmount: 0 });
            this.setState({ isLoading: false });
            this.setState({ selectItem: 'first' });
            this.setState({ isPaid: true });
            this.setState({ isQuotation: false });
            this.setState({ bucketId: '' });
            this.setState({ bucketName: '' });
            this.setState({ bucketStock: 0 });
            this.setState({ bucketUnitPrice: 0 });
            this.setState({ bucketTotalPrice: 0 });
            this.setState({ total_buckets: 0 });
            this.setState({ returnBucketTotalPrice: 0 });
            this.setState((prevState) => {
                const updatedReturnBucketInputs = Object.fromEntries(Object.entries(prevState.returnBucketInputs).map(([key, bucket]) => [
                    key,
                    Object.assign(Object.assign({}, bucket), { qty: 0, cost: 0 }),
                ]));
                return { returnBucketInputs: updatedReturnBucketInputs };
            });
            this.setState((prevState) => {
                const updatedBucketInputs = Object.fromEntries(Object.entries(prevState.bucketInputs).map(([key, bucket]) => [
                    key,
                    Object.assign(Object.assign({}, bucket), { qty: 0, cost: 0 }),
                ]));
                return { bucketInputs: updatedBucketInputs };
            });
        };
        this.togglePaidButton = () => {
            this.setState({ isPaid: !this.state.isPaid });
        };
        this.categoryClick = (category) => {
            this.setState({ productType: 'category' });
            this.setState({ showProducts: true });
            this.setState({ selectItem: category.id });
            this.setState({ products: category.products || [] });
            this.setState({ categoryName: category.name });
        };
        this.carClick = (car) => {
            this.setState({ selectItem: 'car' });
            if (!this.state.cars || this.state.cars.length === 0) {
                this.setState({ isLoading: true });
                this.getCars();
            }
            this.setState({ productType: 'car' });
            this.setState({ isLoading: false });
            this.setState({ showProducts: true });
            this.setState({ products: [] });
            this.setState({ isCarSelect: false });
            this.setState({ isCarSelect: false });
        };
        this.showCarDetails = (car) => {
            this.setState({ selectItem: 'car' });
            this.setState({ productType: 'category' });
            this.setState({ showProducts: true });
            this.setState({ isCarSelect: true });
            this.setState({ products: car.car_details || [] });
            this.setState({ isLoading: false });
        };
        this.getCars = () => {
            this.setState({ isLoading: true });
            httpService
                .get(`/cars-json`)
                .then((response) => {
                this.setState({ cars: response.data.data });
                console.log('Cars loaded:', response.data.data);
            })
                .catch((error) => {
                console.error('Error loading cars:', error);
                this.setState({ cars: [] });
            })
                .finally(() => {
                this.setState({ isLoading: false });
                this.setState({ isLoadingCategories: false });
            });
        };
        this.backClick = () => {
            this.setState({ showProducts: false });
            this.setState({ products: [] });
            this.setState({ productType: 'category' });
            // Don't clear cars array - keep it for next time
            this.setState({ categoryName: '' });
            this.setState({ selectItem: 'first' });
        };
        this.handleDiscountChange = (event) => {
            var value = event.target.value;
            if (Number(value) < 0)
                return;
            var discountValue = value == '' ? undefined : Number(value);
            this.setState({ discount: discountValue }, () => {
                this.calculateTotal();
            });
        };
        this.handleTaxChange = (event) => {
            var value = event.target.value;
            if (Number(value) < 0)
                return;
            var taxValue = value == '' ? undefined : Number(value);
            this.setState({ tax: taxValue }, () => {
                this.calculateTotal();
            });
        };
        this.handleDeliveryChargeChange = (event) => {
            var value = event.target.value;
            if (Number(value) < 0)
                return;
            var deliveryChargeValue = value == '' ? undefined : Number(value);
            this.setState({ deliveryCharge: deliveryChargeValue }, () => {
                this.calculateTotal();
            });
        };
        this.updateItemPrice = (event, item) => {
            var value = event.target.value;
            let cartItems = this.state.cart;
            let _prod = this.state.cart.find(p => p.cartId === item.cartId);
            if (!_prod)
                return;
            if (Number(value) < 0)
                return;
            _prod.price = value == '' ? undefined : Number(value);
            this.setState({ cart: cartItems }, () => {
                this.calculateTotal();
            });
        };
        this.updateItemQtyByClick = (event, item, qty) => {
            var value = qty;
            let cartItems = this.state.cart;
            let _prod = this.state.cart.find(p => p.cartId === item.cartId);
            if (!_prod)
                return;
            if (Number(value) < 0)
                return;
            _prod.quantity = Number(value) || 1;
            this.setState({ cart: cartItems }, () => {
                this.calculateTotal();
            });
        };
        this.toggleFullScreen = () => {
            toogleFullScreen();
            this.setState({ isFullScreen: !this.state.isFullScreen });
        };
        this.goToDashboard = () => {
            window.location.href = '/';
        };
        this.calculateItemPrice = (item) => {
            let price = ((item.price || 0) * (item.quantity || 0) * (100 - Number(item.discount || 0))) / 100.0;
            if (item.vat_type === 'add')
                price = price + (price * Number(item.tax_rate)) / 100;
            else
                price = price - (price * Number(item.tax_rate)) / 100;
            return Number(price.toFixed(2));
        };
        this.calculateTotal = () => {
            let _total = 0;
            let _subtotal = 0;
            let _discount = 0;
            let _bucket_total = 0;
            let _return_bucket_total = 0;
            const exchangeRate = this.state.currency === "USD" ? 1 : 1;
            if (this.state.bucketTotalPrice > 0) {
                _bucket_total = this.state.bucketTotalPrice;
            }
            if (this.state.returnBucketTotalPrice) {
                _return_bucket_total = this.state.returnBucketTotalPrice;
            }
            if (this.state.cart.length > 0) {
                this.state.cart.map((item) => {
                    // console.log(item.retailsale_price);
                    // console.log(item.wholesale_price);
                    // _subtotal += (item.price || 0) * (item.quantity || 0);
                    let item_discount = 0;
                    item_discount = ((item.price || 0) * (item.quantity || 0) * (item.discount || 0)) / 100;
                    _subtotal += ((item.price || 0) * (item.quantity || 0));
                    _discount += item_discount;
                    // _subtotal += ((this.state.currentPrice === 0 ? item.retailsale_price : item.wholesale_price) || 0) * (item.quantity || 0);
                });
            }
            let taxValue = 0;
            if (this.state.vatType == 'add') {
                if ((this.state.tax || 0) > 0 && (this.state.tax || 0) <= 100) {
                    taxValue = (Number(this.state.tax || 0) * Number(_subtotal)) / 100;
                }
            }
            var deliveryCharge = 0;
            if (this.getAppSettings().enableTakeoutAndDelivery) {
                if (this.isOrderDelivery()) {
                    deliveryCharge = Number(this.state.deliveryCharge || 0);
                }
            }
            else {
                deliveryCharge = Number(this.state.deliveryCharge || 0);
            }
            _total = (Number(_bucket_total) + Number(_subtotal) + Number(taxValue) + Number(deliveryCharge) - Number(_discount || 0) - Number(_return_bucket_total)) * exchangeRate;
            this.setState({
                subtotal: _subtotal * exchangeRate,
                total: _total,
                tenderAmount: _total,
                discount: _discount * exchangeRate
            });
        };
        this.getVat = () => {
            var vat = this.state.tax || 0;
            if (vat <= 0)
                return 0;
            var grossAmount = this.state.subtotal || 0;
            var taxAmount = this.getTaxAmount();
            return Math.round(Number(grossAmount) - Number(taxAmount));
        };
        this.getTaxAmount = () => {
            var vat = this.state.tax || 0;
            if (vat <= 0)
                return 0;
            var grossAmount = this.state.subtotal || 0;
            return Math.trunc(Number(grossAmount) / Number(Number(1) + Number(vat) / Number(100)));
        };
        this.getTotalTax = () => {
            let taxValue = 0;
            if (Number(this.state.tax || 0) > 0 && Number(this.state.tax || 0) <= 100) {
                taxValue = (Number(this.state.tax || 0) * Number(this.state.subtotal)) / 100;
            }
            return Number(taxValue);
        };
        this.getChangeAmount = () => {
            return (this.state.tenderAmount || 0) - this.state.total;
        };
        this.handleTenderAmountChange = (event) => {
            var value = event.target.value;
            if (Number(value) < 0)
                return;
            var tenderAmount = value == '' ? undefined : Number(value);
            this.setState({ tenderAmount: tenderAmount });
        };
        this.handleCustomerAmountChange = (event) => {
            var value = event.target.value;
            if (Number(value) < 0)
                return;
            var customerAmount = value == '' ? undefined : Number(value);
            this.setState({
                customerAmount,
                returnAmount: (!customerAmount ? 0 : customerAmount) - (!this.state.tenderAmount ? 0 : this.state.tenderAmount)
            });
        };
        this.handleRemarksChange = (event) => {
            this.setState({ remarks: event.currentTarget.value });
        };
        this.removeItem = (item) => {
            let newCartItems = this.state.cart.filter(i => i.cartId != item.cartId);
            this.setState({ cart: newCartItems }, () => this.calculateTotal());
        };
        this.addToCart = (product, price_type = this.state.currentPrice) => {
            var _b, _j;
            let _price;
            switch (price_type) {
                case 0:
                    _price = product.unit_price;
                    break;
                case 1:
                    _price = product.box_price;
                    break;
                case 2:
                    _price = product.wholesale_price;
                    break;
                case 3:
                    _price = product.price_per_gram;
                    break;
                case 4:
                    _price = product.price_per_kilogram;
                    break;
                default:
                    _price = product.unit_price;
                    return;
            }
            let cartItem = {
                cartId: uuid(),
                id: product.id,
                name: product.name,
                full_name: product.full_name,
                image_url: product.image_url,
                price: _price,
                box_price: product.box_price,
                unit_price: product.unit_price,
                wholesale_price: product.wholesale_price,
                price_per_gram: product.price_per_gram,
                price_per_kilogram: product.price_per_kilogram,
                // barcode: product.barcode,
                box_barcode: product.box_barcode,
                unit_barcode: product.unit_barcode,
                superdealer_barcode: product.superdealer_barcode,
                wholesale_barcode: product.wholesale_barcode,
                pricepergram_barcode: product.pricepergram_barcode,
                priceperkilogram_barcode: product.priceperkilogram_barcode,
                // sku: product.sku,
                box_sku: product.box_sku,
                unit_sku: product.unit_sku,
                superdealer_sku: product.superdealer_sku,
                wholesale_sku: product.wholesale_sku,
                pricepergram_sku: product.unit_sku,
                priceperkilogram_sku: product.unit_sku,
                in_stock: product.in_stock,
                track_stock: product.track_stock,
                continue_selling_when_out_of_stock: product.continue_selling_when_out_of_stock,
                quantity: 1,
                vat_type: this.getAppSettings().vatType,
                tax_rate: 0,
                discount: 0,
                count_per_box: product.count_per_box,
                cost_unit: product.cost_unit,
                box_unit: product.box_unit,
                expiry_date: product.expiry_date,
                price_type: price_type,
                number_of_buckets: product.number_of_buckets ? product.number_of_buckets : 0,
                minimum_stock: product.minimum_stock ? product.minimum_stock : 0,
                car: (_b = product === null || product === void 0 ? void 0 : product.car) !== null && _b !== void 0 ? _b : '',
                car_id: (_j = product === null || product === void 0 ? void 0 : product.car_id) !== null && _j !== void 0 ? _j : '',
            };
            this.setState({ selectItem: 'first' });
            this.setState({ cart: [cartItem, ...this.state.cart] }, () => {
                this.calculateTotal();
            });
            if (this.state.hasaudio) {
                new Audio('/audio/public_audio_ding.mp3').play();
            }
        };
        this.handleSearchSubmit = (event) => {
            event.preventDefault();
            let search = this.state.searchValue;
            if (!search)
                return;
            let searchValue = search.toLowerCase().trim();
            let productFound = false;
            let price_type;
            this.state.categories.map((category) => {
                let _prod;
                for (let index = 0; index < 3; index++) {
                    switch (index) {
                        case 0:
                            _prod = category.products.find(p => {
                                var _b, _j;
                                return p.name.toLowerCase().includes(searchValue) ||
                                    ((_b = p === null || p === void 0 ? void 0 : p.unit_barcode) === null || _b === void 0 ? void 0 : _b.toLowerCase()) == searchValue ||
                                    ((_j = p === null || p === void 0 ? void 0 : p.unit_sku) === null || _j === void 0 ? void 0 : _j.toLowerCase()) == searchValue;
                            }
                            // || p?.barcode?.toLowerCase() == searchValue || p?.sku?.toLowerCase() == searchValue
                            );
                            break;
                        case 1:
                            _prod = category.products.find(p => {
                                var _b, _j;
                                return p.name.toLowerCase().includes(searchValue) ||
                                    ((_b = p === null || p === void 0 ? void 0 : p.box_barcode) === null || _b === void 0 ? void 0 : _b.toLowerCase()) == searchValue ||
                                    ((_j = p === null || p === void 0 ? void 0 : p.box_sku) === null || _j === void 0 ? void 0 : _j.toLowerCase()) == searchValue;
                            }
                            // || p?.barcode?.toLowerCase() == searchValue || p?.sku?.toLowerCase() == searchValue
                            );
                            break;
                        case 2:
                            _prod = category.products.find(p => {
                                var _b, _j;
                                return p.name.toLowerCase().includes(searchValue) ||
                                    ((_b = p === null || p === void 0 ? void 0 : p.wholesale_barcode) === null || _b === void 0 ? void 0 : _b.toLowerCase()) == searchValue ||
                                    ((_j = p === null || p === void 0 ? void 0 : p.wholesale_sku) === null || _j === void 0 ? void 0 : _j.toLowerCase()) == searchValue;
                            }
                            // || p?.barcode?.toLowerCase() == searchValue || p?.sku?.toLowerCase() == searchValue
                            );
                            break;
                        default:
                            // _prod = category.products.find(
                            //     p => p.name.toLowerCase().includes(searchValue) || p?.barcode?.toLowerCase() == searchValue || p?.sku?.toLowerCase() == searchValue
                            // );
                            return;
                    }
                    if (_prod) {
                        price_type = index;
                        break;
                    }
                }
                // for (let i = 0; i < this.state.cart.length; i++) {
                //     if (_prod !== undefined && _prod.id === this.state.cart[i].id) {
                //         _prod = undefined;
                //         break;
                //     }
                // }
                if (_prod) {
                    this.addToCart(_prod, price_type);
                    productFound = true;
                    if (productFound) {
                        this.setState({ searchValue: null });
                        var searchInput = document.getElementById('barcode-input');
                        if (searchInput) {
                            searchInput.value = '';
                        }
                    }
                    return;
                }
            });
            if (!productFound) {
                toast.error(t('No results found!', 'لم يتم العثور على نتائج!'));
            }
        };
        this.handleSearchChange = (event) => {
            this.setState({ searchValue: event.currentTarget.value });
        };
        this.handleVatTypeChange = (event) => {
            this.setState({ vatType: event.target.value }, () => {
                this.calculateTotal();
            });
        };
        this.handleSelectItem = (e) => {
            if (e.currentTarget.value == 'car') {
                this.carClick('car');
            }
            else {
                this.setState({ productType: 'category' });
                this.setState({ isLoading: false });
                this.setState({ showProducts: false });
                this.setState({ products: [] });
            }
            let categoryTemp = this.state.categories.find(category => category.id === e.currentTarget.value);
            if (categoryTemp === null || categoryTemp === void 0 ? void 0 : categoryTemp.id) {
                this.categoryClick(categoryTemp);
            }
        };
        this.handleCustomerSearchChange = (event) => {
            var searchQuery = event.currentTarget.value.trim();
            if (!searchQuery) {
                this.setState({ customers: [] });
                return;
            }
            httpService
                .get(`/customers/search/all?query=${searchQuery}`)
                .then((response) => {
                this.setState({ customers: response.data.data });
            })
                .finally(() => { });
        };
        this.setCustomer = (customer) => {
            this.setState({ customer: customer });
        };
        this.closeModal = (id) => {
            const createModal = document.querySelector(`#${id}`);
            if (createModal) {
                var modalInstance = Modal.getInstance(createModal);
                if (modalInstance) {
                    modalInstance.hide();
                }
            }
        };
        this.getAppSettings = () => {
            return JSON.parse(this.props.settings);
        };
        this.currencyFormatValue = (number) => {
            var settings = this.getAppSettings();
            return currency_format(number, settings.currencyPrecision, settings.currencyDecimalSeparator, settings.currencyThousandSeparator, settings.currencyPosition, settings.currencySymbol, settings.trailingZeros);
        };
        this.receiptExchangeRate = () => {
            var settings = this.getAppSettings();
            var value = Number(this.state.total) * Number(settings.exchangeRate);
            return currency_format(value, 2, '.', ',', 'before', settings.exchangeCurrency, true);
        };
        this.isProductAvailable = (product) => {
            if (product.continue_selling_when_out_of_stock)
                return true;
            if (product.in_stock < Number(product.minimum_stock))
                return false;
            if (!product.track_stock)
                return true;
            if (product.in_stock > 0)
                return true;
            return false;
        };
        this.updateItemQuantity = (event, item) => {
            var value = event.target.value;
            let cartItems = this.state.cart;
            let _prod = this.state.cart.find(p => p.cartId === item.cartId);
            if (!_prod)
                return;
            if (Number(value) < 0)
                return;
            _prod.quantity = value == '' ? undefined : Number(value);
            this.setState({ cart: cartItems }, () => {
                this.calculateTotal();
            });
        };
        this.updateItemPriceType = (event, item) => {
            var value = event.target.value;
            let cartItems = this.state.cart;
            let _prod = this.state.cart.find(p => p.cartId === item.cartId);
            if (!_prod)
                return;
            if (Number(value) < 0)
                return;
            _prod.price_type = value == '' ? 0 : Number(value);
            let _price;
            switch (_prod.price_type) {
                case 0:
                    _price = item.unit_price;
                    break;
                case 1:
                    _price = item.box_price;
                    break;
                case 2:
                    _price = item.wholesale_price;
                    break;
                case 3:
                    _price = item.price_per_gram;
                    break;
                case 4:
                    _price = item.price_per_kilogram;
                    break;
                default:
                    _price = item.unit_price;
                    return;
            }
            _prod.price = _price;
            this.setState({ cart: cartItems }, () => {
                this.calculateTotal();
            });
        };
        this.updateItemVatType = (item) => {
            let cartItems = this.state.cart;
            let _prod = this.state.cart.find(p => p.cartId === item.cartId);
            if (!_prod)
                return;
            _prod.vat_type = item.vat_type === 'exclude' ? 'add' : 'exclude';
            this.setState({ cart: cartItems }, () => {
                this.calculateTotal();
            });
        };
        this.updateItemVAT = (event, item) => {
            var value = event.target.value;
            let cartItems = this.state.cart;
            let _prod = this.state.cart.find(p => p.cartId === item.cartId);
            if (!_prod)
                return;
            if (Number(value) < 0)
                return;
            _prod.tax_rate = value == '' ? undefined : Number(value);
            this.setState({ cart: cartItems }, () => {
                this.calculateTotal();
            });
        };
        this.updateItemDiscount = (event, item) => {
            var value = event.target.value;
            let cartItems = this.state.cart;
            let _prod = this.state.cart.find(p => p.cartId === item.cartId);
            if (!_prod)
                return;
            if (Number(value) < 0)
                return;
            _prod.discount = value == '' ? undefined : Number(value);
            this.setState({ cart: cartItems }, () => {
                this.calculateTotal();
            });
        };
        this.createCustomer = (e) => {
            e.preventDefault();
            if (!this.state.customerName) {
                toast.error(t('Customer name is required!', 'اسم الزبون مطلوب!'));
                return;
            }
            const transformedPlasticBucketStock = Object.entries(this.state.plastic_bucket_stock).reduce((acc, [bucketId, bucket]) => {
                acc[bucketId] = bucket.stock.toString();
                return acc;
            }, {});
            this.setState({ isLoading: true });
            httpService
                .post(`/customers/create-new`, {
                name: this.state.customerName,
                email: this.state.customerEmail,
                mobile: this.state.customerMobile,
                city: this.state.customerCity,
                building: this.state.customerBuilding,
                street_address: this.state.customerStreet,
                floor: this.state.customerFloor,
                apartment: this.state.customerApartment,
                // available_buckets: this.state.bucketNumber,
                plastic_bucket_stock: transformedPlasticBucketStock
            })
                .then((response) => {
                console.log(this.state.plastic_bucket_stock);
                console.log(response.data);
                this.setCustomer(response.data.data);
                this.setState({ customerName: '' });
                this.setState({ customerEmail: '' });
                this.setState({ customerMobile: '' });
                this.setState({ customerBuilding: '' });
                this.setState({ customerStreet: '' });
                this.setState({ customerFloor: '' });
                this.setState({ customerApartment: '' });
                // this.setState({bucketNumber : ''});
                this.setState((prevState) => {
                    const updatedCustomerBuckets = Object.fromEntries(Object.entries(prevState.plastic_bucket_stock).map(([bucketId, bucket]) => [
                        bucketId,
                        Object.assign(Object.assign({}, bucket), { stock: 0 }),
                    ]));
                    return { plastic_bucket_stock: updatedCustomerBuckets };
                });
                var form = document.getElementById('create-customer-form');
                if (form) {
                    form.reset();
                }
                this.closeModal('customerModal');
                toast.info(t('Customer has been created', 'تم إنشاء زبون جديد'));
            })
                .finally(() => {
                this.setState({ isLoading: false });
            });
        };
        this.handleCustomerNameChange = (event) => {
            this.setState({ customerName: event.currentTarget.value });
        };
        this.handleCustomerEmailChange = (event) => {
            this.setState({ customerEmail: event.currentTarget.value });
        };
        this.handleCustomerMobileChange = (event) => {
            this.setState({ customerMobile: event.currentTarget.value });
        };
        this.handleCustomerCityChange = (event) => {
            this.setState({ customerCity: event.currentTarget.value });
        };
        this.handleCustomerStreetChange = (event) => {
            this.setState({ customerStreet: event.currentTarget.value });
        };
        this.handleCustomerBuildingChange = (event) => {
            this.setState({ customerBuilding: event.currentTarget.value });
        };
        this.handleCustomerFloorChange = (event) => {
            this.setState({ customerFloor: event.currentTarget.value });
        };
        this.handleCustomerApartmentChange = (event) => {
            this.setState({ customerApartment: event.currentTarget.value });
        };
        this.handleCustomerBucketChange = (event) => {
            this.setState({ bucketNumber: event.currentTarget.value });
        };
        this.printInvoice = (data, settings) => {
            var receipt = window.open(``, 'PRINT', 'height=600,width=300');
            var order = data.order;
            var barcode = data.barcode;
            let customerInfo = order === null || order === void 0 ? void 0 : order.customer;
            if (!receipt)
                return;
            receipt.document.write(`<html lang="${settings.lang}" dir="${settings.dir}"><head><title>Order Receipt ${order.number}</title></head><body>`);
            receipt.document.write(`<div style="margin-bottom: 1.0rem;text-align: center !important;">`);
            if (settings.storeName) {
                receipt.document.write(`<div style="font-size: 1.50rem;">${settings.storeName}</div>`);
            }
            if (settings.storeAddress) {
                receipt.document.write(`<div style="font-size: 0.875rem;">${settings.storeAddress}</div>`);
            }
            if (settings.storePhone) {
                receipt.document.write(`<div style="font-size: 0.875rem;">${settings.storePhone}</div>`);
            }
            if (settings.storeWebsite) {
                receipt.document.write(`<div style="font-size: 0.675em;">${settings.storeWebsite}</div>`);
            }
            if (settings.storeEmail) {
                receipt.document.write(`<div style="font-size: 0.675em;">${settings.storeEmail}</div>`);
            }
            receipt.document.write(`</div>`);
            // Customer Info
            const customerName = (customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.name) || '';
            const customerContact = (customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.mobile) || "";
            const customerEmail = (customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.email) || "";
            const customerAddress = (customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.street_address) || [
                customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.apartment,
                customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.city,
                customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.floor,
            ].filter(Boolean).join(', ');
            if (customerName || customerContact || customerAddress) {
                receipt.document.write('<div style="margin: 0 0 1.0rem 0; font-size: 0.875rem;">');
                receipt.document.write(`<div style="font-weight: 700;">${t('Customer', 'العميل')}</div>`);
                if (customerName) {
                    receipt.document.write(`<div>${t('Name', 'الاسم')}: ${customerName}</div>`);
                }
                if (customerEmail) {
                    receipt.document.write(`<div>${t('Email', 'بريد إلكتروني')}: ${customerEmail}</div>`);
                }
                if (customerContact) {
                    receipt.document.write(`<div>${t('Contact', 'الاتصال')}: ${customerContact}</div>`);
                }
                if (customerAddress) {
                    receipt.document.write(`<div>${t('Address', 'العنوان')}: ${customerAddress}</div>`);
                }
                receipt.document.write('</div>');
            }
            receipt.document.write('<div style="margin-bottom: 1.0rem">');
            order.order_details.map((detail) => {
                let unit = detail.price_type == 1 ? detail.product.box_unit : detail.product.cost_unit;
                if (receipt) {
                    receipt.document.write(`<div>`);
                    receipt.document.write(`<div>${detail.product.name}</div>`);
                    receipt.document.write(`<div style="display: flex">`);
                    receipt.document.write(`<div>${detail.quantity} (${unit}) * ${detail.view_price}</div>`);
                    receipt.document.write(`<div style="${settings.margin}: auto">${detail.view_total}</div>`);
                    receipt.document.write('</div>');
                    receipt.document.write('</div>');
                }
            });
            receipt.document.write('</div>');
            if (order.discount > 0) {
                receipt.document.write('<div style="display: flex">');
                receipt.document.write(`<div>${t('Discount', 'الخصم')}</div>`);
                receipt.document.write(`<div style="${settings.margin}: auto">${order.discount_view}</div>`);
                receipt.document.write('</div>');
            }
            if (this.getAppSettings().enableTakeoutAndDelivery) {
                if (this.isOrderDelivery()) {
                    if (order.delivery_charge > 0) {
                        receipt.document.write('<div style="display: flex">');
                        receipt.document.write(`<div>${t('Delivery Charge', 'رسوم التوصيل')}:</div>`);
                        receipt.document.write(`<div style="${settings.margin}: auto">${order.delivery_charge_view}</div>`);
                        receipt.document.write('</div>');
                    }
                }
            }
            else {
                if (order.delivery_charge > 0) {
                    receipt.document.write('<div style="display: flex">');
                    receipt.document.write(`<div>${t('Delivery Charge', 'رسوم التوصيل')}:</div>`);
                    receipt.document.write(`<div style="${settings.margin}: auto">${order.delivery_charge_view}</div>`);
                    receipt.document.write('</div>');
                }
            }
            if (order.tax_rate > 0) {
                if (order.vat_type == 'add') {
                    receipt.document.write('<div style="display: flex;">');
                    receipt.document.write(`<div>${t('VAT', 'الضريبة')} (${order.tax_rate}%):</div>`);
                    receipt.document.write(`<div style="${settings.margin}: auto">${order.total_tax_view}</div>`);
                    receipt.document.write('</div>');
                }
                else {
                    receipt.document.write('<div style="display: flex;">');
                    receipt.document.write(`<div>${t('Subtotal', 'المجموع')}</div>`);
                    receipt.document.write(`<div style="${settings.margin}: auto">${order.subtotal_view}</div>`);
                    receipt.document.write('</div>');
                    receipt.document.write('<div style="display: flex;">');
                    receipt.document.write(`<div>${t('TAX.AMOUNT', 'قيمة الضريبة')}</div>`);
                    receipt.document.write(`<div style="${settings.margin}: auto">${order.tax_amount_view}</div>`);
                    receipt.document.write('</div>');
                    receipt.document.write('<div style="display: flex;">');
                    receipt.document.write(`<div>${t('VAT', 'الضريبة')} ${order.tax_rate}%:</div>`);
                    receipt.document.write(`<div style="${settings.margin}: auto">${order.vat_view}</div>`);
                    receipt.document.write('</div>');
                }
            }
            receipt.document.write(`<div style="font-weight:700;">${t('Plastic Buckets Sold', 'دلو بلاستيك')}</div>`);
            if (order.plastic_bucket_stock) {
                Object.values(order.plastic_bucket_stock).forEach((bucket) => {
                    if (receipt && bucket.qty > 0) {
                        receipt.document.write('<div style="display: flex">');
                        receipt.document.write(`<div>${bucket.category_name} - (${bucket.qty} *  ${bucket.cost})</div>`);
                        receipt.document.write(`<div style="${settings.margin}: auto">${this.currencyFormatValue(bucket.qty * bucket.cost)}</div>`);
                        receipt.document.write('</div>');
                    }
                });
            }
            receipt.document.write('<div style="display: flex">');
            receipt.document.write(`<div>${t('Total', 'المجموع')}</div>`);
            receipt.document.write(`<div style="${settings.margin}: auto; font-weight:700;">${this.currencyFormatValue(order.bucketTotalPrice)}</div></div>`);
            receipt.document.write('<hr/>');
            receipt.document.write(`<div style="font-weight:700;">${t('Plastic Buckets Returned', 'دلاء بلاستيكية تم إرجاعها')}</div>`);
            if (order.returned_plastic_bucket_stock) {
                Object.values(order.returned_plastic_bucket_stock).forEach((bucket) => {
                    if (receipt && bucket.qty > 0) {
                        receipt.document.write('<div style="display: flex">');
                        receipt.document.write(`<div>${bucket.category_name} - (${bucket.qty} *  ${bucket.cost})</div>`);
                        receipt.document.write(`<div style="${settings.margin}: auto">${this.currencyFormatValue(bucket.qty * bucket.cost)}</div>`);
                        receipt.document.write('</div>');
                    }
                });
            }
            receipt.document.write('<div style="display: flex">');
            receipt.document.write(`<div>${t('Total', 'المجموع')}</div>`);
            receipt.document.write(`<div style="${settings.margin}: auto; font-weight:700;">${this.currencyFormatValue(order.returnBucketTotalPrice)}</div></div>`);
            receipt.document.write('<hr/>');
            receipt.document.write('<div style="font-weight: 700">');
            receipt.document.write(`<div>${t('Total', 'المجموع')}</div>`);
            receipt.document.write(`<div style="display: flex;">`);
            receipt.document.write(`<div style="${settings.margin}: auto">${order.total_view}</div>`);
            receipt.document.write('</div>');
            receipt.document.write(`<div style="display: flex;">`);
            receipt.document.write(`<div style="${settings.margin}: auto">${order.receipt_exchange_rate}</div>`);
            receipt.document.write('</div>');
            receipt.document.write('</div>');
            receipt.document.write('<div style="text-align: center !important;margin-bottom: 0.5rem !important;">');
            receipt.document.write(`<span style="margin-right: 1rem">${order.date_view}</span> <span>${order.time_view}</span>`);
            receipt.document.write('</div>');
            receipt.document.write(`<div style="text-align: center !important;margin-bottom: 0.5rem !important;">${order.number}</div>`);
            receipt.document.write(`<div style="display: flex;align-items: center !important;justify-content: center">${barcode}</div>`);
            if (settings.storeAdditionalInfo) {
                receipt.document.write(`<div style="font-size: 0.875em;text-align: center !important;margin-bottom: 0.5rem !important;">${settings.storeAdditionalInfo}</div>`);
            }
            receipt.document.write('</body></html>');
            receipt.document.close();
            receipt.focus();
            receipt.print();
            receipt.close();
        };
        this.modalCloseButton = () => {
            return React.createElement("button", { type: "button", className: "btn-close", "data-bs-dismiss": "modal", "aria-label": "Close" });
        };
        this.modalCloseButtonWhite = () => {
            return React.createElement("button", { type: "button", className: "btn-close btn-close-white", "data-bs-dismiss": "modal", "aria-label": "Close" });
        };
        this.handleOrderTypeChange = (event) => {
            this.setState({ orderType: event.target.value }, () => {
                this.calculateTotal();
            });
        };
        this.isOrderDelivery = () => {
            return this.state.orderType == 'delivery';
        };
        this.allProducts = () => {
            var products = [];
            this.state.categories.map((category) => {
                category.products.map((product) => {
                    products.push(product);
                });
            });
            return products;
        };
        this.handleCloseModal = () => {
            this.closeModal('checkoutModal');
        };
        this.handleIsSalesmanChange = (e) => {
            // Handle the change event
            const selectedSalesmanId = e.target.value; // Get the selected salesman's ID
            const selectedSalesman = this.state.salesmen.find(salesman => String(salesman.id) === selectedSalesmanId); // Find the salesman object from the state
            this.setState({ selectedSalesmanId, selectedSalesman });
        };
        this.handleCurrencyChange = (e) => {
            const selectedCurrency = e.target.value;
            this.setState({ currency: selectedCurrency }, () => {
                this.calculateTotal();
            });
        };
        this.handleIsRootChange = (e) => {
            // Handle the change event
            const selectedRootId = e.target.value; // Get the selected salesman's ID
            const selectedRoot = this.state.roots.find(root => String(root.id) === selectedRootId); // Find the salesman object from the state
            this.setState({ selectedRootId, selectedRoot });
        };
        this.handleIsLineChange = (e) => {
            // Handle the change event
            const selectedLineId = e.target.value; // Get the selected salesman's ID
            const selectedLine = this.state.lines.find(line => String(line.id) === selectedLineId); // Find the salesman object from the state
            this.setState({ selectedLineId, selectedLine });
        };
        this.handleIsQuotationChange = (event) => {
            this.setState({
                isQuotation: event.target.value == 'Quotation'
            });
        };
        this.handleBucketIdChange = (event) => {
            var _b;
            const selectedBucketId = event.target.value;
            const bktName = this.state.buckets.find(bkt => String(bkt.id) === selectedBucketId);
            this.setState({
                bucketId: selectedBucketId
            });
            this.setState({
                bucketName: (_b = bktName === null || bktName === void 0 ? void 0 : bktName.category_name) !== null && _b !== void 0 ? _b : ""
            });
        };
        this.handlebucketStock = (event) => {
            var _b;
            const selectedBucketId = event.target.value;
            let _bt = Number(selectedBucketId) * this.state.bucketUnitPrice;
            this.setState({
                bucketStock: (_b = Number(selectedBucketId)) !== null && _b !== void 0 ? _b : 0
            });
            this.setState({ bucketTotalPrice: _bt }, () => {
                this.calculateTotal();
            });
        };
        this.handleBucketUnitPrice = (event) => {
            var _b;
            const selectedBucketId = event.target.value;
            let _bt = Number(selectedBucketId) * this.state.bucketStock;
            this.setState({
                bucketUnitPrice: (_b = Number(selectedBucketId)) !== null && _b !== void 0 ? _b : 0
            });
            this.setState({ bucketTotalPrice: _bt }, () => {
                this.calculateTotal();
            });
        };
        this.pricesFilter = () => {
            return (React.createElement("div", { className: "dropdown" },
                React.createElement("button", { type: "button", className: "nav-link bg-white border px-3 py-2 rounded-3 clickable-cell", "data-bs-toggle": "modal", "data-bs-target": "#myModal" },
                    React.createElement("div", { className: "d-flex align-items-center" },
                        React.createElement("div", { className: "d-flex justify-content-between align-items-center" },
                            React.createElement("div", { className: "me-5" }, priceFilterList[this.state.currentPrice]),
                            React.createElement(ChevronDownIcon, { className: "hero-icon-xs" }))))));
        };
        this.handleSelectRadio = (index) => {
            this.setState({ currentPrice: index }, () => {
                this.calculateTotal();
            });
            this.closeModal('myModal');
        };
        this.pricesFilterModal = () => {
            return (React.createElement("div", { className: "modal zoom-out-entrance", id: "myModal", tabIndex: -1, "aria-labelledby": "myModalLabel", "aria-hidden": "true" },
                React.createElement("div", { className: "modal-dialog modal-dialog-centered" },
                    React.createElement("div", { className: "modal-content" }, priceFilterList.map((item, index) => {
                        return (React.createElement("div", { className: "modal-header" },
                            React.createElement("div", { className: "d-flex justify-content-between w-100 user-select-none cursor-pointer", onClick: () => this.handleSelectRadio(index) },
                                React.createElement("div", null, item),
                                React.createElement("input", { type: "radio", checked: this.state.currentPrice === index }))));
                    })))));
        };
        this.state = {
            categories: [],
            products: [],
            cart: [],
            customers: [],
            cars: [],
            selectedCar: undefined,
            productType: props.userRole === 'cashier' ? 'car' : 'category',
            customer: undefined,
            customerName: null,
            customerEmail: null,
            customerMobile: null,
            customerCity: null,
            customerBuilding: null,
            customerStreet: null,
            customerFloor: null,
            customerApartment: null,
            bucketNumber: null,
            showProducts: false,
            categoryName: null,
            orderType: 'takeout',
            subtotal: 0,
            total: 0,
            tax: 0,
            vatType: this.getAppSettings().vatType,
            deliveryCharge: 0,
            hasaudio: true,
            discount: 0,
            searchValue: null,
            remarks: null,
            isFullScreen: isFullScreen(),
            tenderAmount: 0,
            returnAmount: 0,
            customerAmount: 0,
            isLoading: false,
            isLoadingCategories: true,
            selectItem: 'first',
            currentPrice: 0,
            currency: "USD",
            isPaid: true,
            isQuotation: false,
            bucketId: '',
            bucketName: '',
            bucketStock: 0,
            bucketUnitPrice: 0,
            bucketTotalPrice: 0,
            selectedSalesmanId: '',
            selectedBucketId: undefined,
            selectedRootId: '',
            selectedLineId: '',
            selectedSalesman: undefined,
            selectedRoot: undefined,
            selectedLine: undefined,
            salesmen: [],
            roots: [],
            lines: [],
            buckets: [],
            bucketInputs: {},
            total_buckets: 0,
            returnBucketInputs: {},
            returnBucketTotalPrice: 0,
            plastic_bucket_stock: {},
            isCarSelect: false,
        };
    }
    componentDidMount() {
        var settings = this.getAppSettings();
        this.setState({ tax: settings.taxRate });
        this.setState({ deliveryCharge: settings.deliveryCharge });
        this.setState({ discount: settings.discount });
        this.setState({ hasaudio: settings.newItemAudio });
        this.setState({ vatType: settings.vatType });
        // Debug: Log user role
        console.log('User role:', this.props.userRole);
        // Check user role and load appropriate data
        if (this.props.userRole === 'cashier') {
            // For cashier role, only load cars and set productType to 'car'
            console.log('Loading cars for cashier role');
            this.setState({ productType: 'car' });
            this.getCars();
        }
        else {
            // For other roles, load categories
            console.log('Loading categories for non-cashier role');
            this.getCategories();
            // Also load cars for non-cashier users (they can access both)
            this.getCars();
        }
        this.calculateTotal();
        // this.getBuckets(); 
        this.setState({ tenderAmount: this.state.total });
        window.onbeforeunload = event => {
            return 'Are you sure?';
        };
        axios
            .get('/api/salesmen')
            .then(response => {
            // Set the fetched data to the state
            const { salesmen, roots, lines } = response.data;
            this.setState({ salesmen, roots, lines });
        })
            .catch(error => {
            console.error('Error fetching data!', error);
        });
        // === set the bucket data
        axios
            .get('/api/getBuckets')
            .then(response => {
            // Set the fetched data to the state
            const { buckets } = response.data;
            this.setState({ buckets });
            this.setState({
                bucketInputs: buckets.reduce((acc, bucket) => {
                    acc[bucket.id] = bucket;
                    return acc;
                }, {})
            });
            this.setState({
                returnBucketInputs: buckets.reduce((acc, bucket) => {
                    acc[bucket.id] = Object.assign({}, bucket);
                    return acc;
                }, {})
            });
            this.setState({
                plastic_bucket_stock: buckets.reduce((acc, bucket) => {
                    acc[bucket.id] = Object.assign(Object.assign({}, bucket), { stock: 0 });
                    return acc;
                }, {})
            });
        })
            .catch(error => {
            console.error('Error fetching data!', error);
        });
    }
    selectCustomer(customer) {
        this.setState({ customer: customer });
        this.closeModal('customerModal');
    }
    removeCustomer() {
        this.setState({ customer: undefined });
    }
    removeBucket() {
        this.setState({ bucketId: '' });
        this.setState({ bucketName: '' });
        this.setState({ bucketStock: 0 });
        this.setState({ bucketUnitPrice: 0 });
        this.setState({ bucketTotalPrice: 0 }, () => {
            this.calculateTotal();
        });
    }
    render() {
        var _b;
        const { selectedSalesmanId, selectedSalesman, selectedRootId, selectedRoot, selectedLineId, selectedLine } = this.state;
        const overallTotal = this.state.buckets.reduce((acc, bucket) => {
            const { qty = 0, cost = 0 } = this.state.bucketInputs[bucket.id] || {};
            return acc + ((qty || 0) * (cost || 0));
        }, 0);
        const returnOverallTotal = this.state.buckets.reduce((acc, bucket) => {
            const { qty = 0, cost = 0 } = this.state.returnBucketInputs[bucket.id] || {};
            return acc + ((qty || 0) * (cost || 0));
        }, 0);
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "d-flex py-3" },
                React.createElement("div", { className: "d-flex flex-grow-1" },
                    React.createElement("div", { className: "flex-grow-1 d-flex" },
                        React.createElement("button", { className: "btn btn-primary me-2", onClick: event => this.goToDashboard() },
                            React.createElement("span", { className: "d-flex align-items-center" },
                                React.createElement(Squares2X2Icon, { className: "hero-icon me-1" }),
                                " ",
                                t('Dashboard', 'الرئيسية'))),
                        React.createElement("button", { className: "btn btn-light me-3 bg-white border", "data-bs-toggle": "modal", "data-bs-target": "#customerModal" },
                            React.createElement("span", { className: "d-flex align-items-center" },
                                React.createElement(UserCircleIcon, { className: "hero-icon me-1" }),
                                " ",
                                t('Customer', 'الزبون'))),
                        React.createElement("button", { className: "btn btn-primary me-5", onClick: event => this.scan_barcode() }, "Scan Barcode"),
                        React.createElement("button", { className: "btn btn-danger me-5", onClick: event => this.reset() },
                            React.createElement("span", { className: "d-flex align-items-center" },
                                React.createElement(ArrowPathIcon, { className: "hero-icon me-1" }),
                                " ",
                                t('Reset?', 'إعادة ضبط'))),
                        React.createElement("select", { name: "is_quotation", id: "is_quotation", className: "form-select me-3", defaultValue: "Invoice", onChange: e => this.handleIsQuotationChange(e) },
                            React.createElement("option", { value: "Inovoice" }, t('Invoice', 'فاتورة')),
                            React.createElement("option", { value: "Quotation" }, t('Quotation', 'اقتباس'))),
                        React.createElement("select", { name: "salesman", id: "salesman", value: selectedSalesmanId, className: "form-select me-3", onChange: this.handleIsSalesmanChange },
                            React.createElement("option", { value: "", disabled: true }, "Select Salesman"),
                            this.state.salesmen.map(salesman => (React.createElement("option", { key: salesman.id, value: salesman.id }, salesman.salesman_name)))),
                        React.createElement("select", { name: "roots", id: "roots", value: selectedRootId, className: "form-select me-3", onChange: this.handleIsRootChange },
                            React.createElement("option", { value: "", disabled: true }, "Select Root"),
                            this.state.roots.map(root => (React.createElement("option", { key: root.id, value: root.id }, root.root_name)))),
                        React.createElement("select", { name: "lines", id: "lines", value: selectedLineId, className: "form-select me-3", onChange: this.handleIsLineChange },
                            React.createElement("option", { value: "", disabled: true }, "Select Line"),
                            this.state.lines.map(line => (React.createElement("option", { key: line.id, value: line.id }, line.location)))),
                        React.createElement("select", { name: "currency", id: "currency", value: this.state.currency, className: "form-select me-3", onChange: this.handleCurrencyChange },
                            React.createElement("option", { value: "", disabled: true }, "Select Currency"),
                            currencyFilterList.map(currency => (React.createElement("option", { key: currency, value: currency }, currency))))),
                    this.pricesFilter(),
                    this.pricesFilterModal()),
                React.createElement("div", { className: "d-flex" }, this.getAppSettings().enableTakeoutAndDelivery && (React.createElement("select", { name: "order-type", id: "order-type", className: "form-select form-select-lg px-5", defaultValue: "takeout", onChange: e => this.handleOrderTypeChange(e) },
                    React.createElement("option", { value: "takeout" }, t('Takeout', 'أستلام')),
                    React.createElement("option", { value: "delivery" }, t('Delivery', 'توصيل')))))),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-8" },
                    React.createElement("div", { className: "card w-100 card-gutter rounded-0" },
                        React.createElement("div", { className: "card-header bg-white border-bottom-0 p-0" },
                            React.createElement("form", { onSubmit: event => this.handleSearchSubmit(event) },
                                React.createElement("input", { type: "search", className: "form-control form-control-lg rounded-0", name: "search", id: "barcode-input", placeholder: t('Scannn barcode or search by name or SKU', 'امسح الباركود ضوئيًا أو ابحث بالاسم أو SKU'), onChange: event => this.handleSearchChange(event) })),
                            React.createElement("table", { className: "table table-bordered mb-0" },
                                React.createElement("thead", null,
                                    React.createElement("tr", null,
                                        React.createElement("td", { width: 400, className: "p-3 fw-bold" }, t('Item', 'الصنف')),
                                        React.createElement("td", { width: 150, className: "text-center p-3 fw-bold" }, t('Price Type', 'نوع السعر')),
                                        React.createElement("td", { width: 150, className: "text-center p-3 fw-bold" }, t('Quantity', 'الكمية')),
                                        React.createElement("td", { width: 150, className: "text-center p-3 fw-bold" },
                                            t('VAT', 'الضريبة'),
                                            " %"),
                                        React.createElement("td", { width: 150, className: "text-center p-3 fw-bold" },
                                            t('Discount', 'الخصم'),
                                            " %"),
                                        React.createElement("td", { width: 150, className: "text-center p-3 fw-bold" }, t('Total', 'المجموع')))))),
                        React.createElement("div", { className: "card-body p-0 overflow-auto", id: "cartItems" },
                            React.createElement("table", { className: "table table-bordered mb-0", style: tableStyles },
                                React.createElement("tbody", null, this.state.cart.length > 0 ? (React.createElement(React.Fragment, null, this.state.cart.map((item) => {
                                    return (React.createElement("tr", { key: item.cartId },
                                        React.createElement("td", { className: "align-middle" },
                                            React.createElement("div", { className: "d-flex align-items-center" },
                                                React.createElement("img", { src: item.image_url, alt: "item", className: "rounded-2", height: 50 }),
                                                React.createElement("div", { className: "ms-2" },
                                                    React.createElement("div", { className: "fw-bold" },
                                                        this.state.categoryName,
                                                        " - ",
                                                        item.full_name),
                                                    React.createElement("div", { className: "fw-normal" },
                                                        React.createElement("input", { type: "number", className: "form-control text-center", value: item.price, onFocus: e => e.target.select(), onChange: e => this.updateItemPrice(e, item) }))),
                                                React.createElement("div", { className: "me-auto d-flex align-items-center" },
                                                    React.createElement(XCircleIcon, { className: "hero-icon-sm align-middle text-danger cursor-pointer user-select-none", onClick: event => this.removeItem(item) })))),
                                        React.createElement("td", { className: "align-middle" },
                                            React.createElement("select", { className: "form-control text-center", onChange: event => this.updateItemPriceType(event, item) }, priceFilterList.map((priceItem, index) => (React.createElement("option", { value: index, selected: index === item.price_type }, priceItem))))),
                                        React.createElement("td", { className: "align-middle" },
                                            React.createElement("input", { type: "number", className: "form-control text-center fw-bold form-control-lg", value: item.quantity, onFocus: e => e.target.select(), onChange: event => this.updateItemQuantity(event, item) })),
                                        React.createElement("td", { className: "align-middle" },
                                            React.createElement("div", { onClick: event => this.updateItemVatType(item) }, item.vat_type),
                                            React.createElement("input", { type: "number", className: "form-control text-center fw-bold form-control-lg", value: item.tax_rate, onFocus: e => e.target.select(), onChange: event => this.updateItemVAT(event, item) })),
                                        React.createElement("td", { className: "align-middle" },
                                            React.createElement("input", { type: "number", className: "form-control text-center fw-bold form-control-lg", value: item.discount, onFocus: e => e.target.select(), onChange: event => this.updateItemDiscount(event, item) })),
                                        React.createElement("td", { className: "text-center align-middle" }, this.calculateItemPrice(item))));
                                }))) : (React.createElement(React.Fragment, null,
                                    React.createElement("tr", null,
                                        React.createElement("td", { colSpan: 9, className: "p-3 text-center align-middle fs-5" }, t('No items added...', 'لا توجد اصناف مضافة ...')))))))),
                        React.createElement("div", { className: " card-footer p-0 bg-white", id: "orderDetails" },
                            React.createElement("table", { className: "table table-bordered mb-0" },
                                React.createElement("tbody", null,
                                    React.createElement("tr", null,
                                        React.createElement("td", { colSpan: 3, width: 200, className: "text-center align-end clickable-cell", onClick: this.togglePaidButton }, this.state.isPaid === true ? 'Paid' : 'Unpaid')),
                                    React.createElement("tr", null,
                                        React.createElement("td", { width: 200 },
                                            t('Customer', 'الزبون'),
                                            ":",
                                            ' ',
                                            this.state.customer ? React.createElement("span", { className: "fw-bold" },
                                                this.state.customer.name,
                                                " ",
                                                React.createElement("br", null),
                                                "Balance:",
                                                this.state.customer.balance,
                                                " ") : 'N/A',
                                            this.state.customer && (React.createElement("div", { className: "float-end" },
                                                React.createElement(XCircleIcon, { className: "hero-icon-sm align-middle text-danger cursor-pointer user-select-none", onClick: event => this.removeCustomer() })))),
                                        React.createElement("td", { width: 200, className: "text-end" }, t('Subtotal', 'المجموع')),
                                        React.createElement("td", { width: 200, className: "align-middle text-center" }, this.currencyFormatValue(this.state.subtotal))),
                                    React.createElement("tr", null,
                                        React.createElement("td", { width: 200, className: "text-start align-middle clickable-cell", "data-bs-toggle": "modal", "data-bs-target": "#deliveryChargeModal" }, this.getAppSettings().enableTakeoutAndDelivery ? (React.createElement(React.Fragment, null, this.isOrderDelivery() && (React.createElement(React.Fragment, null,
                                            t('Delivery Charge', 'رسوم التوصيل'),
                                            " :",
                                            ' ',
                                            this.state.deliveryCharge
                                                ? this.currencyFormatValue(this.state.deliveryCharge)
                                                : 'N/A')))) : (React.createElement(React.Fragment, null,
                                            t('Delivery Charge', 'رسوم التوصيل'),
                                            " :",
                                            ' ',
                                            this.state.deliveryCharge ? this.currencyFormatValue(this.state.deliveryCharge) : 'N/A'))),
                                        React.createElement("td", { width: 200, className: "text-end align-middle clickable-cell", "data-bs-toggle": "modal", "data-bs-target": "#discountModal" }, t('Discount', 'الخصم')),
                                        React.createElement("td", { width: 200, className: "text-center text-danger align-middle clickable-cell", "data-bs-toggle": "modal", "data-bs-target": "#discountModal" }, this.currencyFormatValue(this.state.discount || 0))),
                                    React.createElement("tr", { className: "alert-success" },
                                        this.state.vatType == 'add' ? (React.createElement("td", { width: 200, className: "text-start clickable-cell", "data-bs-toggle": "modal", "data-bs-target": "#taxModal" },
                                            t('VAT', 'الضريبة'),
                                            " ",
                                            this.state.tax,
                                            "%: ",
                                            this.currencyFormatValue(this.getTotalTax()))) : (React.createElement("td", { width: 200, className: "text-start clickable-cell", "data-bs-toggle": "modal", "data-bs-target": "#taxModal" },
                                            React.createElement("div", null,
                                                t('TAX.AMOUNT', 'قيمة الضريبة'),
                                                ": ",
                                                this.currencyFormatValue(this.getTaxAmount())),
                                            React.createElement("div", null,
                                                t('VAT', 'الضريبة'),
                                                " ",
                                                this.state.tax,
                                                "%: ",
                                                this.currencyFormatValue(this.getVat())))),
                                        React.createElement("td", { width: 200, className: "fw-bold text-end fs-5 align-middle" }, t('Total', 'الإجمالي')),
                                        React.createElement("td", { width: 200, className: "text-center align-middle fw-bold fs-5" },
                                            React.createElement("div", null,
                                                " ",
                                                this.currencyFormatValue(this.state.total)),
                                            this.getAppSettings().showExchangeRateOnReceipt && React.createElement("div", null, this.receiptExchangeRate())))))),
                        React.createElement("button", { type: "button", className: "btn btn-success py-4 rounded-0 shadow-sm fs-3 btn-lg w-100", "data-bs-toggle": "modal", "data-bs-target": "#checkoutModal" }, t('CHECKOUT', 'الدفع')))),
                React.createElement("div", { className: "col-md-4" },
                    React.createElement("div", { className: "card w-100 card-gutter rounded-0" },
                        this.props.userRole !== 'cashier' ? (React.createElement("div", { className: "card-header bg-white" },
                            React.createElement("div", { className: "d-flex px-4 justify-content-between align-items-center", style: { minHeight: 'calc(1.5em + 1rem + 5px)', padding: '0.5rem' } },
                                React.createElement("div", { className: "d-flex align-items-center" },
                                    React.createElement("a", { className: "text-decoration-none cursor-pointer pe-2 fs-5", onClick: event => this.backClick() }, t('CATEGORIES', 'الفئات')),
                                    this.state.showProducts && (React.createElement("div", { className: "d-flex align-items-center" },
                                        this.getAppSettings().dir == 'rtl' ? (React.createElement(ArrowLeftIcon, { className: "hero-icon pe-2" })) : (React.createElement(ArrowRightIcon, { className: "hero-icon pe-2" })),
                                        React.createElement("span", { className: "fw-normal text-muted pe-2 fs-5 text-uppercase", "aria-current": "page" }, this.state.productType === 'car' ? 'Car' : this.state.categoryName),
                                        this.getAppSettings().dir == 'rtl' ? (React.createElement(ArrowLeftIcon, { className: "hero-icon pe-2" })) : (React.createElement(ArrowRightIcon, { className: "hero-icon pe-2" }))))),
                                React.createElement("select", { name: "product", className: "form-control w-50", value: this.state.selectItem, onChange: e => this.handleSelectItem(e) },
                                    React.createElement("option", { value: "first" }, "Select item"),
                                    this.props.userRole !== 'cashier' && React.createElement("option", { value: "car" }, "Car"),
                                    this.state.categories.length > 0 &&
                                        this.state.categories.map((item) => React.createElement("option", { value: item.id }, item.name))))))
                            : (React.createElement("div", { className: 'alert alert-light text-center' },
                                this.state.isCarSelect && this.getAppSettings().dir == 'rtl' ? (React.createElement("div", { className: 'd-inline', onClick: event => this.carClick('car') },
                                    React.createElement(ArrowRightIcon, { className: "hero-icon pe-2" }))) : (React.createElement("div", { className: 'd-inline', onClick: event => this.carClick('car') },
                                    " ",
                                    React.createElement(ArrowLeftIcon, { className: "hero-icon pe-2" }))),
                                React.createElement("span", { className: "fw-normal text-muted pe-2 fs-5 text-uppercase", "aria-current": "page" }, "Cars"))),
                        React.createElement("div", { className: "card-body overflow-auto py-0" },
                            this.state.isLoadingCategories === true && (React.createElement("div", { className: "py-5" },
                                React.createElement("div", { className: "d-flex justify-content-center m-2" },
                                    React.createElement("div", { className: "spinner-border text-primary", role: "status", style: { width: '4rem', height: '4rem' } },
                                        React.createElement("span", { className: "visually-hidden" }, t('Loading...', 'جاري التحميل...')))),
                                React.createElement("div", { className: "fw-bold h3 text-center" }, t('Loading...', 'جاري التحميل...')))),
                            !this.state.showProducts && (React.createElement(React.Fragment, null,
                                this.props.userRole !== 'cashier' && this.state.categories.length > 0 && (React.createElement("div", { className: "row" },
                                    this.state.categories.map((category) => {
                                        return (React.createElement("div", { key: category.id, className: "col-lg-4 col-md-4 col-sm-6 col-6 mb-0 p-0" },
                                            React.createElement("div", { className: "position-relative w-100 border cursor-pointer user-select-none", onClick: event => this.categoryClick(category) },
                                                React.createElement("picture", null,
                                                    React.createElement("source", { type: "image/jpg", srcSet: category.image_url }),
                                                    React.createElement("img", { alt: category.name, src: category.image_url, "aria-hidden": "true", className: "object-fit-cover h-100 w-100" })),
                                                React.createElement("div", { className: "position-absolute bottom-0 start-0 h-100 d-flex flex-column align-items-center justify-content-center p-4 mb-0 w-100 cell-item-label text-center" },
                                                    React.createElement("div", { className: "product-name", dir: "auto" }, category.name)))));
                                    }),
                                    React.createElement("div", { className: "col-lg-4 col-md-4 col-sm-6 col-6 mb-0 p-0" },
                                        React.createElement("div", { className: "position-relative w-100 border cursor-pointer user-select-none", onClick: event => this.carClick('car') },
                                            React.createElement("picture", null,
                                                React.createElement("img", { alt: "Car", src: "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='800' height='600'></svg>", "aria-hidden": "true", className: "object-fit-cover h-100 w-100" })),
                                            React.createElement("div", { className: "position-absolute bottom-0 start-0 h-100 d-flex flex-column align-items-center justify-content-center p-4 mb-0 w-100 cell-item-label text-center" },
                                                React.createElement("div", { className: "product-name", dir: "auto" }, "Car")))))),
                                this.props.userRole === 'cashier' && (React.createElement("div", { className: "row overflow-auto" }, this.state.cars.map((car) => {
                                    return (React.createElement("div", { key: car.id, className: "col-lg-4 col-md-4 col-sm-6 col-6 mb-0 p-0" },
                                        React.createElement("div", { className: "position-relative w-100 border cursor-pointer user-select-none", onClick: event => this.showCarDetails(car) },
                                            React.createElement("div", { className: "p-3 text-center" },
                                                React.createElement("div", { className: "fw-bold fs-5" }, car.car_name),
                                                React.createElement("div", { className: "text-muted" }, car.car_type),
                                                React.createElement("div", { className: "small text-muted mt-1" },
                                                    React.createElement("div", null,
                                                        "Driver: ",
                                                        car.car_driver_name),
                                                    React.createElement("div", null,
                                                        "Phone: ",
                                                        car.car_driver_phone),
                                                    React.createElement("div", null,
                                                        "Date: ",
                                                        car.stock_date))))));
                                }))))),
                            this.state.showProducts && (React.createElement(React.Fragment, null, this.state.productType === 'car' ? (React.createElement("div", { className: "row overflow-auto" }, this.state.cars.map((car) => {
                                return (React.createElement("div", { key: car.id, className: "col-lg-4 col-md-4 col-sm-6 col-6 mb-0 p-0" },
                                    React.createElement("div", { className: "position-relative w-100 border cursor-pointer user-select-none", onClick: event => this.showCarDetails(car) },
                                        React.createElement("div", { className: "p-3 text-center" },
                                            React.createElement("div", { className: "fw-bold fs-5" }, car.car_name),
                                            React.createElement("div", { className: "text-muted" }, car.car_type),
                                            React.createElement("div", { className: "small text-muted mt-1" },
                                                React.createElement("div", null,
                                                    "Driver: ",
                                                    car.car_driver_name),
                                                React.createElement("div", null,
                                                    "Phone: ",
                                                    car.car_driver_phone),
                                                React.createElement("div", null,
                                                    "Date: ",
                                                    car.stock_date))))));
                            }))) : this.state.products.length > 0 && (React.createElement("div", { className: "row overflow-auto" }, this.state.products.map((product) => {
                                var _b, _j, _k;
                                // console.log(product);
                                let _price;
                                switch (this.state.currentPrice) {
                                    case 0:
                                        _price = product.unit_price;
                                        break;
                                    case 1:
                                        _price = product.box_price;
                                        break;
                                    case 2:
                                        _price = product.wholesale_price;
                                        break;
                                    case 3:
                                        _price = product.price_per_gram;
                                        break;
                                    case 4:
                                        _price = product.price_per_kilogram;
                                        break;
                                    default:
                                        _price = product.unit_price;
                                        return;
                                }
                                return (React.createElement(React.Fragment, null, this.isProductAvailable(product) && (React.createElement("div", { key: product.id, className: "col-lg-4 col-md-4 col-sm-6 col-6 mb-0 p-0" },
                                    React.createElement("div", { className: "position-relative w-100 border cursor-pointer user-select-none", onClick: event => this.addToCart(product) },
                                        React.createElement("picture", null,
                                            React.createElement("source", { type: "image/jpg", srcSet: (product === null || product === void 0 ? void 0 : product.image_url) || '' }),
                                            React.createElement("img", { alt: product.name, src: product.image_url, "aria-hidden": "true", className: "object-fit-cover h-100 w-100" })),
                                        React.createElement("div", { className: "position-absolute bottom-0 start-0 h-100 d-flex flex-column align-items-center justify-content-center p-4 mb-0 w-100 cell-item-label text-center" },
                                            React.createElement("div", { className: "fw-normal" }, this.currencyFormatValue(_price || 0)),
                                            React.createElement("div", { className: "fw-bold", dir: "auto" }, (_j = (_b = product === null || product === void 0 ? void 0 : product.full_name) !== null && _b !== void 0 ? _b : product === null || product === void 0 ? void 0 : product.name) !== null && _j !== void 0 ? _j : ''),
                                            React.createElement("div", { className: "fw-normal" },
                                                this.state.currentPrice === 1
                                                    ? Math.floor(product.in_stock / (product.count_per_box || 10))
                                                    : product.in_stock,
                                                "(",
                                                this.state.currentPrice === 1 ? product.box_unit : product.cost_unit,
                                                ")"),
                                            React.createElement("div", { className: "fw-normal" }, (_k = product.expiry_date) !== null && _k !== void 0 ? _k : '')))))));
                            }))))))))),
            React.createElement("div", { className: "modal zoom-out-entrance", id: "discountModal", tabIndex: -1, "aria-labelledby": "discountModalLabel", "aria-hidden": "true" },
                React.createElement("div", { className: "modal-dialog modal-dialog-centered" },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("div", { className: "modal-header" },
                            React.createElement("h5", { className: "modal-title", id: "discountModalLabel" }, t('Discount', 'الخصم')),
                            this.modalCloseButton()),
                        React.createElement("div", { className: "modal-body" },
                            React.createElement("h3", { className: "text-center" }, this.currencyFormatValue(this.state.discount || 0)),
                            React.createElement("div", { className: "mb-3" },
                                React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", onFocus: e => e.target.select(), value: this.state.discount, onChange: this.handleDiscountChange })))))),
            React.createElement("div", { className: "modal zoom-out-entrance", id: "deliveryChargeModal", tabIndex: -1, "aria-labelledby": "deliveryChargeModalLabel", "aria-hidden": "true" },
                React.createElement("div", { className: "modal-dialog modal-dialog-centered" },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("div", { className: "modal-header" },
                            React.createElement("h5", { className: "modal-title d-flex", id: "deliveryChargeModalLabel" }, t('Delivery Charge', 'رسوم التوصيل')),
                            this.modalCloseButton()),
                        React.createElement("div", { className: "modal-body" },
                            React.createElement("h3", { className: "text-center" }, this.currencyFormatValue(this.state.deliveryCharge || 0)),
                            React.createElement("div", { className: "mb-3" },
                                React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", value: this.state.deliveryCharge, onChange: this.handleDeliveryChargeChange, onFocus: e => e.target.select() })))))),
            React.createElement("div", { className: "modal zoom-out-entrance", id: "taxModal", tabIndex: -1, "aria-labelledby": "taxModalLabel", "aria-hidden": "true" },
                React.createElement("div", { className: "modal-dialog modal-dialog-centered" },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("div", { className: "modal-header" },
                            React.createElement("h5", { className: "modal-title", id: "taxModalLabel" }, t('VAT', 'الضريبة')),
                            this.modalCloseButton()),
                        React.createElement("div", { className: "modal-body" },
                            React.createElement("h3", { className: "text-center" },
                                this.state.tax || 0,
                                "%"),
                            React.createElement("div", { className: "mb-3" },
                                React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", onFocus: e => e.target.select(), value: this.state.tax, onChange: this.handleTaxChange })),
                            React.createElement("div", { className: "mb-3" },
                                React.createElement("select", { name: "vatType", id: "vat-type", className: "form-select form-select-lg", onChange: this.handleVatTypeChange, value: this.state.vatType },
                                    React.createElement("option", { value: "exclude" },
                                        " ",
                                        t('Exclude', 'استثناء')),
                                    React.createElement("option", { value: "add" }, t('Add', 'إضافة')))))))),
            React.createElement("div", { className: "modal zoom-out-entrance", id: "customerModal", tabIndex: -1, "aria-labelledby": "customerModalLabel", "aria-hidden": "true" },
                React.createElement("div", { className: "modal-dialog modal-dialog-centered" },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("div", { className: "modal-header" },
                            React.createElement("h5", { className: "modal-title d-flex", id: "customerModalLabel" }, t('Customer', 'الزبون')),
                            this.modalCloseButton()),
                        React.createElement("div", { className: "modal-body p-0" },
                            React.createElement("nav", null,
                                React.createElement("div", { className: "nav nav-tabs nav-justified", id: "nav-tab", role: "tablist" },
                                    React.createElement("button", { className: "nav-link rounded-0 active", id: "nav-search-customer-tab", "data-bs-toggle": "tab", "data-bs-target": "#nav-search-customer", type: "button", role: "tab", "aria-controls": "nav-search-customer", "aria-selected": "true" }, t('Search', 'ابحث')),
                                    React.createElement("button", { className: "nav-link rounded-0", id: "nav-create-customer-tab", "data-bs-toggle": "tab", "data-bs-target": "#nav-create-customer", type: "button", role: "tab", "aria-controls": "nav-create-customer", "aria-selected": "false" }, t('Create', 'إنشاء')))),
                            React.createElement("div", { className: "tab-content", id: "nav-tabContent" },
                                React.createElement("div", { className: "tab-pane fade show active", id: "nav-search-customer", role: "tabpanel", "aria-labelledby": "nav-search-customer-tab", tabIndex: 0 },
                                    React.createElement("div", { className: "position-relative w-100" },
                                        React.createElement("input", { type: "search", className: "form-control form-control-lg rounded-0 shadow-none", name: "search", id: "search", autoComplete: "off", placeholder: t('Search...', 'بحث...'), onChange: event => this.handleCustomerSearchChange(event) })),
                                    React.createElement("div", { className: "overflow-auto", style: { height: '250px' } }, this.state.customers.length > 0 && (React.createElement(React.Fragment, null, this.state.customers.map((cuts) => {
                                        return (React.createElement("div", { className: "py-2 px-3 clickable-cell border-bottom", onClick: e => this.selectCustomer(cuts), key: cuts.id },
                                            React.createElement("div", { className: "fw-bold" }, cuts.name),
                                            React.createElement("div", { className: "small text-muted" }, cuts.contact),
                                            React.createElement("div", { className: "small text-muted" }, cuts.full_address)));
                                    }))))),
                                React.createElement("div", { className: "tab-pane fade p-3", id: "nav-create-customer", role: "tabpanel", "aria-labelledby": "nav-create-customer-tab", tabIndex: 0 },
                                    React.createElement("form", { method: "POST", onSubmit: this.createCustomer, role: "form", id: "create-customer-form" },
                                        React.createElement("div", { className: "mb-3" },
                                            React.createElement("label", { className: " form-label fw-bold" },
                                                t('Customer Name', 'اسم الزبون'),
                                                "*"),
                                            React.createElement("input", { type: "text", className: "form-control form-control-lg", onChange: event => this.handleCustomerNameChange(event) })),
                                        React.createElement("div", { className: "mb-3" },
                                            React.createElement("label", { className: " form-label fw-bold" }, t('Email', 'البريد الإلكتروني')),
                                            React.createElement("input", { type: "email", className: "form-control form-control-lg", onChange: event => this.handleCustomerEmailChange(event) })),
                                        React.createElement("div", { className: "mb-3" },
                                            React.createElement("label", { className: " form-label fw-bold" }, t('Mobile Number', 'رقم الجوال')),
                                            React.createElement("input", { type: "tel", className: "form-control form-control-lg", onChange: event => this.handleCustomerMobileChange(event) })),
                                        React.createElement("div", { className: "text-muted" }, t('Address', 'العنوان')),
                                        React.createElement("div", { className: "mb-3" },
                                            React.createElement("label", { className: " form-label fw-bold" }, t('City', 'المدينة')),
                                            React.createElement("input", { type: "text", className: "form-control form-control-lg", onChange: event => this.handleCustomerCityChange(event) })),
                                        React.createElement("div", { className: "row" },
                                            React.createElement("div", { className: "col-md-6 mb-3" },
                                                React.createElement("label", { className: " form-label fw-bold" }, t('Street', 'الشارع')),
                                                React.createElement("input", { type: "text", className: "form-control form-control-lg", onChange: event => this.handleCustomerStreetChange(event) })),
                                            React.createElement("div", { className: "col-md-6 mb-3" },
                                                React.createElement("label", { className: " form-label fw-bold" }, t('Building', 'المبنى')),
                                                React.createElement("input", { type: "text", className: "form-control form-control-lg", onChange: event => this.handleCustomerBuildingChange(event) }))),
                                        React.createElement("div", { className: "row" },
                                            React.createElement("div", { className: "col-md-6 mb-3" },
                                                React.createElement("label", { className: " form-label fw-bold" }, t('Floor', 'الطابق')),
                                                React.createElement("input", { type: "text", className: "form-control form-control-lg", onChange: event => this.handleCustomerFloorChange(event) })),
                                            React.createElement("div", { className: "col-md-6 mb-3" },
                                                React.createElement("label", { className: " form-label fw-bold" }, t('Apartment', 'الشقة')),
                                                React.createElement("input", { type: "text", className: "form-control form-control-lg", onChange: event => this.handleCustomerApartmentChange(event) })),
                                            React.createElement("div", { className: "col-md-12 mb-3" },
                                                React.createElement("table", { width: "100%" },
                                                    React.createElement("thead", null,
                                                        React.createElement("tr", null,
                                                            React.createElement("th", null, "Bucket Types"),
                                                            React.createElement("th", null, "Stock"))),
                                                    React.createElement("tbody", null, this.state.buckets.map((bucket) => {
                                                        var _b, _j;
                                                        // Use plastic_bucket_stock for the input value,
                                                        // falling back to 0 if not available.
                                                        const value = (_j = (_b = this.state.plastic_bucket_stock[bucket.id]) === null || _b === void 0 ? void 0 : _b.stock) !== null && _j !== void 0 ? _j : 0;
                                                        return (React.createElement("tr", { key: bucket.id },
                                                            React.createElement("td", { width: "50%" }, bucket.category_name),
                                                            React.createElement("td", null,
                                                                React.createElement("input", { type: "number", className: "form-control text-center w-full", value: value, onChange: (e) => this.handleStockChange(bucket.id, e) }))));
                                                    }))))),
                                        React.createElement("button", { className: "btn btn-primary btn-lg w-100", type: "submit", disabled: this.state.isLoading }, t('Create Customer', 'إنشاء زبون جديد'))))))))),
            React.createElement("div", { className: "modal zoom-out-entrance", id: "checkoutModal", tabIndex: -1, "aria-labelledby": "checkoutModalLabel", "aria-hidden": "true" },
                React.createElement("div", { className: "modal-dialog modal-dialog-centered modal-lg" },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("div", { className: "modal-header" },
                            React.createElement("h5", { className: "modal-title", id: "checkoutModalLabel" }),
                            this.modalCloseButton()),
                        React.createElement("div", { className: "modal-body py-0" },
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col-6 py-3 bg-primary-sec" },
                                    React.createElement("table", { className: "table table-borderless" },
                                        React.createElement("tbody", null,
                                            React.createElement("tr", null,
                                                React.createElement("td", { className: "text-danger-sec" },
                                                    " ",
                                                    t('Subtotal', 'المجموع')),
                                                React.createElement("td", { className: "text-white" }, this.currencyFormatValue(this.state.subtotal))),
                                            React.createElement("tr", null,
                                                React.createElement("td", { className: "text-danger-sec" },
                                                    " ",
                                                    t('Quantity', 'الكمية')),
                                                React.createElement("td", { className: "text-white" }, this.state.cart.reduce(function (prev, current) {
                                                    return prev + +(current.quantity || 0);
                                                }, 0))),
                                            React.createElement("tr", null,
                                                React.createElement("td", { className: "text-danger-sec" },
                                                    " ",
                                                    t('Discount', 'الخصم')),
                                                React.createElement("td", { className: "text-white" }, this.currencyFormatValue(this.state.discount || 0))),
                                            React.createElement("tr", null,
                                                React.createElement("td", { className: "text-danger-sec" },
                                                    " ",
                                                    t('Delivery Charge', 'رسوم التوصيل')),
                                                React.createElement("td", { className: "text-white" }, this.currencyFormatValue(this.state.deliveryCharge || 0))),
                                            this.state.vatType == 'add' ? (React.createElement("tr", null,
                                                React.createElement("td", { className: "text-danger-sec" },
                                                    ' ',
                                                    t('VAT', 'الضريبة'),
                                                    " ",
                                                    this.state.tax || 0,
                                                    "%"),
                                                React.createElement("td", { className: "text-white" }, this.currencyFormatValue(this.getTotalTax())))) : (React.createElement(React.Fragment, null,
                                                React.createElement("tr", null,
                                                    React.createElement("td", { className: "text-danger-sec" },
                                                        " ",
                                                        t('Tax Amount', 'القيمة الضريبية')),
                                                    React.createElement("td", { className: "text-white" }, this.currencyFormatValue(this.getTaxAmount()))),
                                                React.createElement("tr", null,
                                                    React.createElement("td", { className: "text-danger-sec" },
                                                        t('VAT', 'الضريبة'),
                                                        " ",
                                                        this.state.tax || 0,
                                                        "%"),
                                                    React.createElement("td", { className: "text-white" }, this.currencyFormatValue(this.getVat()))))),
                                            React.createElement("tr", { className: "fw-bold" },
                                                React.createElement("td", { className: "text-danger-sec" },
                                                    " ",
                                                    t('Bucket Total', 'إجمالي الدلو')),
                                                React.createElement("td", { className: "text-white" }, this.currencyFormatValue(this.state.bucketTotalPrice))),
                                            React.createElement("tr", { className: "fw-bold" },
                                                React.createElement("td", { className: "text-danger-sec" },
                                                    " ",
                                                    t('Returned Bucket Total', 'إجمالي الدلو المرتجع')),
                                                React.createElement("td", { className: "text-white" }, this.currencyFormatValue(this.state.returnBucketTotalPrice))),
                                            React.createElement("tr", { className: "fw-bold" },
                                                React.createElement("td", { className: "text-danger-sec" },
                                                    " ",
                                                    t('Total', 'المجموع الإجمالي')),
                                                React.createElement("td", { className: "text-white" }, this.currencyFormatValue(this.state.total))),
                                            this.state.customer && (React.createElement(React.Fragment, null,
                                                React.createElement("tr", null,
                                                    React.createElement("td", { className: "text-danger-sec align-middle" },
                                                        " ",
                                                        t('Customer', 'الزبون')),
                                                    React.createElement("td", { className: "text-white" }, this.state.customer.name)),
                                                React.createElement("tr", null,
                                                    React.createElement("td", { className: "text-danger-sec align-middle" }, t('Contact', 'الاتصال')),
                                                    React.createElement("td", { className: "text-white" }, this.state.customer.contact)),
                                                React.createElement("tr", null,
                                                    React.createElement("td", { className: "text-danger-sec align-middle" }, t('Address', 'العنوان')),
                                                    React.createElement("td", { className: "text-white" }, this.state.customer.full_address)))))),
                                    React.createElement("hr", null),
                                    React.createElement("div", { className: "mb-3" },
                                        React.createElement("label", { htmlFor: "remarks", className: "form-label text-danger-sec" }, t('Notes', 'الملاحظات')),
                                        React.createElement("textarea", { className: "form-control", id: "remarks", rows: 3, onChange: event => this.handleRemarksChange(event) }, this.state.remarks))),
                                React.createElement("div", { className: "col-6 py-3 bg-body d-flex flex-column" },
                                    React.createElement("div", { className: "text-center text-danger" },
                                        " ",
                                        t('CHECKOUT', 'الدفع')),
                                    React.createElement("hr", null),
                                    React.createElement("div", { className: "mb-3" },
                                        React.createElement("div", { className: "form-label text-center" },
                                            " ",
                                            t('Tender Amount', 'المبلغ المدفوع')),
                                        React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", value: (_b = this.state.tenderAmount) === null || _b === void 0 ? void 0 : _b.toFixed(2), onFocus: e => e.target.select(), onChange: this.handleTenderAmountChange })),
                                    React.createElement("div", { className: "mb-3" },
                                        React.createElement("div", { className: "form-label text-center" },
                                            " ",
                                            t('Customer Amount', 'مبلغ العميل')),
                                        React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", value: this.state.customerAmount, onFocus: e => e.target.select(), onChange: this.handleCustomerAmountChange })),
                                    React.createElement("div", { className: "mb-3" },
                                        React.createElement("div", { className: "form-label text-center" },
                                            " ",
                                            t('Return', 'مبلغ العميل')),
                                        React.createElement("div", { className: "form-label text-center" }, this.currencyFormatValue(this.state.returnAmount))),
                                    React.createElement("hr", null),
                                    React.createElement("div", { className: "accordion accordion-flush", id: "accordionFlushExample" },
                                        React.createElement("div", { className: "accordion-item" },
                                            React.createElement("h2", { className: "accordion-header", id: "flush-headingOne" },
                                                React.createElement("button", { className: "accordion-button collapsed", type: "button", "data-bs-toggle": "collapse", "data-bs-target": "#flush-collapseOne", "aria-expanded": "false", "aria-controls": "flush-collapseOne" },
                                                    React.createElement("strong", null, "Sale Plastic Buckets"))),
                                            React.createElement("div", { id: "flush-collapseOne", className: "accordion-collapse collapse", "aria-labelledby": "flush-headingOne", "data-bs-parent": "#accordionFlushExample" },
                                                React.createElement("div", { className: "accordion-body" },
                                                    React.createElement("table", { width: "100%" },
                                                        React.createElement("thead", null,
                                                            React.createElement("tr", null,
                                                                React.createElement("th", null, "Type"),
                                                                React.createElement("th", null, "Qty"),
                                                                React.createElement("th", null, "Cost"),
                                                                React.createElement("th", null, "Total"))),
                                                        React.createElement("tbody", null,
                                                            this.state.buckets.map((bucket) => {
                                                                const { qty, cost } = this.state.bucketInputs[bucket.id] || { qty: 0, cost: 0 };
                                                                return (React.createElement("tr", { key: bucket.id },
                                                                    React.createElement("td", { width: "50%" }, bucket.category_name),
                                                                    React.createElement("td", null,
                                                                        React.createElement("input", { type: "number", className: "form-control text-center w-full", value: qty, onChange: (e) => this.handleQtyChange(bucket.id, e) })),
                                                                    React.createElement("td", null,
                                                                        React.createElement("input", { type: "number", className: "form-control text-center w-full", value: cost, onChange: (e) => this.handleCostChange(bucket.id, e) })),
                                                                    React.createElement("td", { align: "right" },
                                                                        "$",
                                                                        (qty * cost).toFixed(2))));
                                                            }),
                                                            React.createElement("tr", null,
                                                                React.createElement("td", { colSpan: 3, align: "right" },
                                                                    React.createElement("strong", null, "Overall Total:")),
                                                                React.createElement("td", { align: "right" },
                                                                    React.createElement("strong", null,
                                                                        "$",
                                                                        overallTotal.toFixed(2)))))))))),
                                    React.createElement("div", { className: "accordion accordion-flush", id: "returnBuckets" },
                                        React.createElement("div", { className: "accordion-item" },
                                            React.createElement("h2", { className: "accordion-header", id: "flush-headingTwo" },
                                                React.createElement("button", { className: "accordion-button collapsed", type: "button", "data-bs-toggle": "collapse", "data-bs-target": "#flush-collapseTwo", "aria-expanded": "false", "aria-controls": "flush-collapseOne" },
                                                    React.createElement("strong", null, "Return Plastic Buckets"))),
                                            React.createElement("div", { id: "flush-collapseTwo", className: "accordion-collapse collapse", "aria-labelledby": "flush-headingTwo", "data-bs-parent": "#returnBuckets" },
                                                React.createElement("div", { className: "accordion-body" },
                                                    React.createElement("table", { width: "100%" },
                                                        React.createElement("thead", null,
                                                            React.createElement("tr", null,
                                                                React.createElement("th", null, "Type"),
                                                                React.createElement("th", null, "Qty"),
                                                                React.createElement("th", null, "Cost"),
                                                                React.createElement("th", null, "Total"))),
                                                        React.createElement("tbody", null,
                                                            this.state.buckets.map((bucket) => {
                                                                const { qty, cost } = this.state.returnBucketInputs[bucket.id] || { qty: 0, cost: 0 };
                                                                return (React.createElement("tr", { key: bucket.id },
                                                                    React.createElement("td", { width: "50%" }, bucket.category_name),
                                                                    React.createElement("td", null,
                                                                        React.createElement("input", { type: "number", className: "form-control text-center w-full", value: qty, onChange: (e) => this.handleReturnQtyChange(bucket.id, e) })),
                                                                    React.createElement("td", null,
                                                                        React.createElement("input", { type: "number", className: "form-control text-center w-full", value: cost, onChange: (e) => this.handleReturnCostChange(bucket.id, e) })),
                                                                    React.createElement("td", { align: "right" },
                                                                        "$",
                                                                        (qty * cost).toFixed(2))));
                                                            }),
                                                            React.createElement("tr", null,
                                                                React.createElement("td", { colSpan: 3, align: "right" },
                                                                    React.createElement("strong", null, "Overall Return Total:")),
                                                                React.createElement("td", { align: "right" },
                                                                    React.createElement("strong", null,
                                                                        "$",
                                                                        returnOverallTotal.toFixed(2)))))))))),
                                    React.createElement("hr", null),
                                    React.createElement("table", { className: "table table-borderless d-none" },
                                        React.createElement("tbody", null,
                                            React.createElement("tr", { className: "fw-bold" },
                                                React.createElement("td", { className: "text-danger-sec" }, this.getChangeAmount() < 0 ? t('Owe', 'مدين') : t('Change', 'الباقي')),
                                                React.createElement("td", { className: "text-end" }, this.currencyFormatValue(this.getChangeAmount()))))),
                                    React.createElement("div", { className: "mt-auto" },
                                        React.createElement("button", { className: "btn btn-primary btn-lg py-3 w-100", disabled: this.state.isLoading, onClick: e => {
                                                e.preventDefault();
                                                this.storeOrder();
                                            } }, t('SUBMIT', 'حفظ'))))))))),
            React.createElement(ToastContainer, { position: "bottom-left", autoClose: 2000, pauseOnHover: true, theme: "colored", hideProgressBar: true })));
    }
}
export default PointOfSale;
const element = document.getElementById('pos');
if (element) {
    const settings = element.dataset.settings;
    const userRole = element.dataset.userRole || '';
    const root = ReactDOM.createRoot(element);
    root.render(React.createElement(PointOfSale, { settings: settings, userRole: userRole }));
}
